export function isValidVatIT(v) {
  if (!v) return true;
  const s = String(v).trim();
  if (!/^\d{11}$/.test(s)) return false;
  let sum = 0;
  for (let i = 0; i < 11; i++) {
    let n = parseInt(s[i], 10);
    if (i % 2 === 1) { n *= 2; if (n > 9) n -= 9; }
    sum += n;
  }
  return sum % 10 === 0;
}

export function isValidIBAN(v) {
  if (!v) return true;
  const s = String(v).replace(/\s+/g, "").toUpperCase();
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(s)) return false;
  const re = s.slice(4) + s.slice(0, 4);
  let rem = 0;
  for (const ch of re) {
    const code = /\d/.test(ch) ? ch : (ch.charCodeAt(0) - 55).toString();
    for (const d of code) rem = (rem * 10 + parseInt(d, 10)) % 97;
  }
  return rem === 1;
}
